import { render, staticRenderFns } from "./albumItem.vue?vue&type=template&id=5a5b9041&scoped=true"
import script from "./albumItem.vue?vue&type=script&lang=js"
export * from "./albumItem.vue?vue&type=script&lang=js"
import style0 from "./albumItem.vue?vue&type=style&index=0&id=5a5b9041&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5b9041",
  null
  
)

export default component.exports